// extracted by css-extract-rspack-plugin
export default {"root":"KFJnnNxj_VMdsS2k","chart":"GDpuGuQzhgJts2XE"};